import { LocationSubdivisionView } from '@img-arena/consoles-api-streaming'
import { toPercentage } from '@/components/HistoricalStatistics/utils'
import { Column, COLUMN_CELL_TYPE } from '@/components/table/base'
import { US_SUBDIVISIONS } from '@/constants/regions'
import { secondsToHMS } from '@/utils/secondsToHMS'

export const US_STATES_VIEWS_COLUMNS: Column<LocationSubdivisionView>[] = [
  {
    id: 'subdivision',
    label: 'State',
    type: COLUMN_CELL_TYPE.TEXT,
    sortAttribute: 'subdivision',
    transform: (subdivision) => US_SUBDIVISIONS.find((sub) => sub.code === subdivision)?.name || ''
  },
  {
    id: 'totalViews',
    label: 'Total Views',
    type: COLUMN_CELL_TYPE.TEXT,
    sortAttribute: 'totalViews'
  },
  {
    id: 'percentageViews',
    label: 'Percentage Views',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: toPercentage,
    sortAttribute: 'percentageViews'
  },
  {
    id: 'averageDuration',
    label: 'Average Duration',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: (value) => secondsToHMS(value),
    sortAttribute: 'averageDuration'
  }
]
